import React, {useMemo} from 'react';
import {Button, Table} from "antd";
import {MARGIN_XS} from '../../../../../styles/constants';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {compose} from 'redux';
import _ from 'lodash';
import {deleteDSDValueComponentToTable, showDsdComponentModal} from '../actions';


const mapStateToProps = state => ({
    appLanguage: state.app.language,
    showTranscodingSettingsWithoutTimeDimension: state.scenes.mappingHandler.mappingSet.transcoding.showTranscodingSettingsWithoutTimeDimension,
    data: state.scenes.mappingHandler.mappingSet.transcoding.data,
    rulesToTranscoding: state.scenes.mappingHandler.mappingSet.transcoding.rulesToTranscoding,
    columnDataset: state.scenes.mappingHandler.mappingSet.transcoding.columnDataset,
    columnCodelist: state.scenes.mappingHandler.mappingSet.transcoding.columnCodelist,
    dataTable: state.scenes.mappingHandler.mappingSet.transcoding.dataTable,
})

const mapDispatchToProps = dispatch => ({
    onShowDsdComponentModal: (index) => dispatch(showDsdComponentModal(index)),
    onDeleteDsdComponentToRow: (index) => dispatch(deleteDSDValueComponentToTable(index)),
})


const RulesTableTranscoding = ({
                                   columnDataset,
                                   dataTable,
                                   data,
                                   languageSelector,
                                   onShowDsdComponentModal,
                                   onDeleteDsdComponentToRow,
                                   t
                               }) => {

    const columnsTable = useMemo(() => {
        const lang = _.capitalize(languageSelector)
        const cols = !!data ? [...(_.map(columnDataset, 'column')), data.dsdColumnName] : []
        return cols.map((col, idx) => ({
            key: `${idx === cols.length - 1 ? 'Component' : 'Column'}${col}`,
            dataIndex: col,
            title: `${idx === cols.length - 1 ? 'Component' : 'Column'} ${col}`,
            sorter: false,
            sortOrder: false,
            width: 300,
            filterDropdownVisible: false,
            filterMultiple: false,
            render: (record, row) => {
                if (idx === cols.length - 1) {
                    return (
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                         <span style={{textWrap: "wrap"}}>{(!!row && !!row.Component && !!row.Component.Code) ? row.Component.Code : ""}
                             {(!!row && !!row.Component && !!row.Component.Code && (!!row.Component.NameIt || !!row.Component.NameEn)) ?
                                 _.keys(row.Component).map(e => _.endsWith(e, lang) && `: ${row.Component[e]}`).filter(Boolean).reduce(e => e) : ""}
                         </span>
                            <div style={{display: 'flex', flexDirection: 'row', gap: 8, marginLeft: '8px'}}>
                                <Button icon="plus" className="button-color-green" size="small" shape="circle"
                                        onClick={() => onShowDsdComponentModal(row.key)}
                                        title={t('commons.buttons.create.title') +'/' + t('commons.buttons.edit.title')}/>
                                <Button icon="delete" type="primary" size="small" shape="circle"
                                        onClick={() => onDeleteDsdComponentToRow(row.key)}
                                        title={t('commons.actions.delete.title')}/>
                            </div>
                        </div>
                    )
                } else {
                    return (<span>{record}</span>)
                }
            }
        }))

    }, [columnDataset, data, languageSelector])


    return (
        <Table
            scroll={{
                x: true
            }}
            useFixedHeader={false}
            style={{marginTop: MARGIN_XS}}
            bordered={true}
            columns={columnsTable}
            dataSource={dataTable}
            size="small"
            rowKey={(row) => row.key}
            pagination={false}
            expandRowByClick={false}
            loading={false}
            defaultExpandAllRows={false}
        />
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(RulesTableTranscoding);